import * as React from 'react';
import { connect } from 'react-redux';
import { Image } from 'semantic-ui-react';
import { Application } from 'components/presentational';
import { ErrorHandler } from 'components/containers';
import { Layout, Footer, LayoutContent, LayoutHeader } from 'theme';
import { UserMenu } from 'components/presentational/application';
import { ROUTES } from 'config/routes';
import * as AppLogic from 'application';
import { withRouter } from 'react-router-dom';
import {CssClasses } from 'theme';

interface IAppProps {
	onHeaderClicked();
}

const mapStateToProps = (state) => ({

});

const mapDispatchToProps = (dispatch) => ({
	onHeaderClicked: () => AppLogic.Navigation.redirectTo(dispatch, ROUTES.HOME),
});


const App: React.SFC<IAppProps> = (props) => {
	
	const logo = (<div >
					<Image className={CssClasses.Mobile.hidden} src='/assets/images/ff-logo-white.png' style={{ width: 200 }} label={{ color: 'black', content: 'BETA', floating:true, style:{top:10, left:200} }} />
					<Image className={CssClasses.Desktop.hidden} src='/assets/images/logo-white.png' style={{ width: 80, marginLeft:0 }} label={{ color: 'black', content: 'BETA', floating:true, size:'mini', style:{top:20, left:88} }} />
				 </div>);
	return (
		<Layout>
			<LayoutHeader onHeaderClick={props.onHeaderClicked} logo={logo}  >
				<UserMenu />
			</LayoutHeader>
			<LayoutContent>
				<ErrorHandler />
				<Application.ContentView />
			</LayoutContent>
			<Footer />
		</Layout>
	);
}


const AppState = connect(mapStateToProps, mapDispatchToProps)(App);
export default withRouter<any>(AppState);


// WEBPACK FOOTER //
// ./src/App.tsx